import { render, staticRenderFns } from "./RelatoriosExportacoesCustomizadas.vue?vue&type=template&id=5c67f921&"
import script from "./RelatoriosExportacoesCustomizadas.vue?vue&type=script&lang=js&"
export * from "./RelatoriosExportacoesCustomizadas.vue?vue&type=script&lang=js&"
import style0 from "./RelatoriosExportacoesCustomizadas.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports